import {axiosInstance} from "../helpers/axios";

const getJobs = (data) => {
    return axiosInstance.post('getJobs/', data ).then((res) => {
        const data = res.data;
        return data;
    }).
    catch(err => {
        console.log("error");
        console.log(err.message);
    });
}

export default { getJobs };